export const PagerdutyIconUrl = "https://pagerduty.com/favicon.ico";
